import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/helpPages.css';

import {ASSETS_URL} from '../../../../constants/endpoints';

import {getText} from '../../../../helpers/localization';
// actions
import {openCloseHelpPages} from '../../../../actions/helpPagesActions';

const mapStateToProps = (state, ownProps) => {
    return {
        isHelpPagesOpen: state.vpp.isHelpPagesOpen,
        isDesktopMode: state.vpp.isDesktopMode,
        isVideoVisible: state.vpp.isVideoVisible
    };
};

class HelpPages extends Component {
    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
            isDesktopMode: storeData.vpp.isDesktopMode,
            isVideoVisible: storeData.vpp.isVideoVisible
        };
    }

    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();
        this.setState(
            {
                isHelpPagesOpen: storeData.vpp.isHelpPagesOpen,
                isDesktopMode: storeData.vpp.isDesktopMode,
                isVideoVisible: storeData.vpp.isVideoVisible
            }
        );
    }

    _closeHelpPages(event) {
        event.stopPropagation();
        this.props.store.dispatch(openCloseHelpPages());
    }

    render() {

        let helpPagesContainerStyle;
        if (this.state.isDesktopMode) {
            if (this.state.isVideoVisible) {
                helpPagesContainerStyle = style.helpPagesContainer;
            } else {
                helpPagesContainerStyle = style.helpPagesContainerCenter;
            }
        } else {
            helpPagesContainerStyle = style.helpPagesContainerMobile;
        }

        return (
            <div className={style.helpPagesBackground} onClick={(event) => this._closeHelpPages(event)}>
                <div className={helpPagesContainerStyle} onClick={(event) => event.stopPropagation()}>
                    <div className={style.topContainer}>
                        <div className={style.titleContainer}>
                            <div className={style.title}>
                                {getText('HELP', this.props.store)}
                            </div>
                        </div>
                        <div id='helpPagesCloseBtn' onClick={(event) => this._closeHelpPages(event)}>
                            <img src={`${ASSETS_URL}close.svg`} className={style.closeButton} alt={'close'}/>
                        </div>
                    </div>
                    <div id={'helpPages_container'} className={style.content}
                         onClick={(event) => event.stopPropagation()}></div>

                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(HelpPages);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/containers/helpPages.js